import React from 'react';
import Component from '../../components/Component';
import DbInfo from '../../dbinfo';
import * as Constants from '../../constants';
import Renderers from '../../helpers/Renderers';
import Toolbar from '../../components/Toolbar';
import {Button, ButtonToolbar} from 'react-bootstrap';
import {RxForm, FormManager, FormField, FormRow, Multiform} from 'reactis-forms';
import {TextInput, TextArea, Number, DatePicker, RadioList, FileUpload, ImageUpload, Select, Checkbox} from 'reactis-inputs';
import {actions as formactions} from 'reactis-forms';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {AlertWindow, ConfirmWindow} from 'reactis-modal';
import FormDB from '../../components/FormDB';
import {Loader, LoadingButton} from 'reactis-loader';
import ActionButton from '../../components/ActionButton';
import SaveButton from '../../components/SaveButton';
import DocumentTitle from 'react-document-title';
import NavBar from '../../components/NavBar';

@connect((state, props) => {
		return {
			form: state.forms.get('profile')
		};
	},
	(dispatch) => {
		return {actions: bindActionCreators(formactions, dispatch)};
	}, null, {withRef: true })
export default class Form extends FormDB {


	constructor(props, context) {
		super(props, context);

		this.api = {
			fetch: 'user.fetchProfile',
			save: 'user.saveProfile'
		};

		//this.changeEvent = 'user.change';

		this.messages = {
			notfound: 'Nastavení nenalezeno!'
		};

		this.schema = {
			oldpassword: {
				class: TextInput,
				type: 'password',
				label: 'Aktuální heslo',
				autoComplete: 'off'
				/*rules: {
				 presence: {message: 'Zadejte aktuální heslo!'}
				 }*/
			},
			password: {
				class: TextInput,
				type: 'password',
				label: 'Nové heslo',
				autoComplete: 'off'
				/*rules: {
				 presence: {message: 'Zadejte nové heslo!'}
				 }*/
			},
			passwordConfirm: {
				class: TextInput,
				type: 'password',
				label: 'Heslo pro kontrolu',
				autoComplete: 'off',
				rules: {
					equality: {
						attribute: 'password',
						message: 'Hesla se musejí shodovat!'
					}
				}
			}
		};
		this.form = new FormManager(this.schema);
	}

	componentDidMount() {
		this.form.on('change', (key, value) => {
			this.changed = true;
		});
		super.componentDidMount();
	}

	load() {
		this.props.actions.load('profile', this.api.fetch).then(a => {
			this.changed = false;
			if (a.error && a.error.code == 404) {
				alert(this.messages.notfound);
			}
		});
	}

	onSave() {
		this.context.flashMessage({message: 'Váš profil byl uložen.'});
		//window.location = '/';
	}

	getFormData() {
		return {...this.form.getValues().toJS()};
	}

	render() {

		const canEdit = true;
		const saveButton = <SaveButton
			disabled={!canEdit}
			loading={!!(this.props.form && this.props.form.get('saving'))}
			onClick={()=>this.save()}
		/>;

		const btns = <ButtonToolbar>
			{saveButton}
		</ButtonToolbar>;

		const data = this.props.form && this.props.form.get('data') && this.props.form.get('data').toJS();
		return (
			<div className="tdidocument">
				<DocumentTitle title="Můj profil" />
				<NavBar title="Můj profil" />
				<div className="panel" style={{paddingBottom: 0}}>
					<div style={{padding:20, position:'relative'}}>
						<Loader visible={!!(this.props.form && this.props.form.get('loading'))} />
						<RxForm ref="form" form={this.form} id="profile">
							<Toolbar title="Můj profil" buttons={btns} />
							<div className="">
								<div className="">
									<fieldset><legend>Změna hesla</legend></fieldset>
									<table className="form">
										<tbody>
										{Object.keys(this.schema).filter((key) => key != 'datagrid_limit').map((key) => {
											return <FormRow key={key} visible={this.schema[key].visible} name={key} labelWidth={175} />
										})}
										<tr className="buttons">
											<th style={{width:135}}></th>
											<td>
												{saveButton}
											</td>
										</tr>
										</tbody>
									</table>
								</div>
							</div>
						</RxForm>
					</div>
				</div>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/containers/User/Profile.js